// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2862":"6b4cffd663a07d07","8007":"8a975f8377fd3fb9"}[chunkId] + ".js";
};